import cloudBlue from '@/assets/img/cloud-blue.png'
import cloudGray from '@/assets/img/cloud-gray.png'
import cloudRed from '@/assets/img/cloud-red.png'
import imgSize from '@/assets/img/size.png'
import styles from './InfoIcons.module.scss'
import { useAppSelector } from '@/hooks'
import { infoIconsSelector } from '@/modules/device-module/store/infoIconsSlice'

import { signal, voltage12, voltage24, VoltageEnum } from '@/utils'
import cn from '@/utils/cn'
import { Box } from '@mui/material'
import Tooltip from '@mui/material/Tooltip'
import dayjs from 'dayjs'
import WarningMessage from '@/modules/device-module/components/header/WarningMessage'
import * as React from 'react'

const s = cn('device-module-info-icons')

const InfoIconsDit = () => {
  const data = useAppSelector(infoIconsSelector)
  return (
    <Box
      display='flex'
      flexDirection='column'
      gap={{ xss: 0.5, lg: 1 }}
      className={s()}
    >
      <Box
        display='flex'
        alignItems='center'
        gap={2}
      >
        <Box
          display='flex'
          alignItems='center'
          gap={1}
          width={{ xss: 140, lg: 160 }}
        >
          <Tooltip
            title={'Состояние подключения'}
            placement='top'
          >
            <img
              src={
                data?.connectionStatus === 1
                  ? cloudBlue
                  : data?.connectionStatus === 2
                    ? cloudGray
                    : data?.connectionStatus === 3
                      ? cloudRed
                      : cloudRed
              }
              height={25}
              width={25}
              alt='Связь'
            />
          </Tooltip>
          <span style={{ color: '#fff' }}>
            {data?.connectionStatus === 1
              ? 'В сети'
              : data?.connectionStatus === 2
                ? 'Не в сети'
                : data?.connectionStatus === 3
                  ? data?.lastPackageDate
                    ? dayjs(data?.lastPackageDate).format('DD.MM.YYYY HH:mm')
                    : 'Нет соединения'
                  : '-'}
          </span>
        </Box>
        {/*<Box*/}
        {/*  display='flex'*/}
        {/*  alignItems='center'*/}
        {/*  gap={0.5}*/}
        {/*  width={95}*/}
        {/*>*/}
        {/*  <Tooltip*/}
        {/*    title={'Оператор связи'}*/}
        {/*    placement='top'*/}
        {/*  >*/}
        {/*    <img*/}
        {/*      src={sim}*/}
        {/*      alt='Сим-карта'*/}
        {/*      width={25}*/}
        {/*      height={25}*/}
        {/*    />*/}
        {/*  </Tooltip>*/}
        {/*  <span style={{ color: '#fff', whiteSpace: 'nowrap' }}>*/}
        {/*    {data?.operator}*/}
        {/*  </span>*/}
        {/*</Box>*/}
        <Box
          display='flex'
          alignItems='center'
          gap={0.5}
        >
          <Tooltip
            title={'Размер'}
            placement='top'
          >
            <img
              src={imgSize}
              alt='Размер'
              width={25}
              height={25}
            />
          </Tooltip>
          <span style={{ color: '#fff', whiteSpace: 'nowrap' }}>
            ДИТ {data?.ditData?.width} X {data?.ditData?.height}
          </span>
        </Box>
      </Box>
      <div className={styles.Warning}>
        {data?.state ? <WarningMessage /> : null}
      </div>
    </Box>
  )
}

export default InfoIconsDit
